__turbopack_context__.v({
  "badge": "badge-module-scss-module__YTngCG__badge",
  "icon": "badge-module-scss-module__YTngCG__icon",
});
